// import { randomHexColorWithArray } from 'random-hex-color-generator';
// import React, { useEffect, useState } from 'react';
// import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

function ConversionRateGraph({ conversionRateData }) {
    // const [sortedPieData, setSortedPieData] = useState([]);
    // const [colors, setColors] = useState([]);

    // useEffect(() => {
    //     const colorsArray = randomHexColorWithArray(conversionRateData.length);
    //     setColors(colorsArray);

    //     setSortedPieData(conversionRateData.sort((a,b) => b.value - a.value));
    // }, [conversionRateData]);

    // const dimensions = {
    //     innerRadius: 65,
    //     outerRadius: 100,
    // }

    // const [graphDimensions, setGraphDimensions] = useState(dimensions);
    // const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // useEffect(() => {
    //     const handleResize = () => {
    //         setWindowWidth(window.innerWidth);
    //     };
    
    //     window.addEventListener('resize', handleResize);
    
    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, []);

    // useEffect(() => {
    //     if (windowWidth < 1153) {
    //         if(windowWidth < 1081) {
    //             setGraphDimensions({
    //                 innerRadius: 55,
    //                 outerRadius: 80,
    //             });
    //         }
    //         else {
    //             setGraphDimensions({
    //                 innerRadius: 60, 
    //                 outerRadius: 90,
    //             });
    //         }
    //     }
    // }, [windowWidth]);

    return (
        <div className="border-[1px] rounded-lg border-[#EAEAEA] col-span-1 min-h-[50vh] p-5 flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <h1 className="font-urbanist-regular font-semibold text-[16px] leading-6">Conversion Rate</h1>
            </div>

            <div className="m-auto">
                <h1 className='font-urbanist-regular font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* <ResponsiveContainer className='relative' width='100%' height="100%">
                <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[10px] text-black'>
                    <div className='flex flex-col items-center gap-2'>
                        <div className="flex gap-2 items-center">
                            <div className='rounded-[4px] h-3 w-3' style={{ backgroundColor: colors[0%colors.length] }}></div>

                            <h2 className='text-[12px] leading-5 font-urbanist-regular font-semibold text-[#666666]'>{sortedPieData[0]?.name}</h2>
                        </div>

                        <h2 className="text-[16px] leading-5 font-urbanist-regular font-semibold">{sortedPieData[0]?.percentage}%</h2>
                    </div>
                </div>

                <PieChart>
                    <Pie
                        data={conversionRateData}
                        innerRadius={graphDimensions.innerRadius}
                        outerRadius={graphDimensions.outerRadius}
                        fill="#8884d8"
                        paddingAngle={0}
                        dataKey="percentage" 
                    >
                        {conversionRateData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer> */}

            {/* <div className="grid grid-cols-2 grid-rows-1 gap-x-16 max-[1280px]:grid-cols-1 max-[1280px]:grid-rows-2 gap-y-4">
                {sortedPieData.slice(1).map((item, index) => {
                    const newColorList = colors.slice(1);
                    const color = newColorList[index % newColorList.length];

                    return (
                        <div className='max-[1280px]:col-span-1 flex w-full gap-2 items-center justify-between' key={index}>
                            <div className="flex gap-2 items-center">
                                <div className='rounded-[4px] h-3 w-3' style={{ backgroundColor: color }}></div>

                                <h2 className='text-[12px] leading-5 font-urbanist-regular font-semibold text-[#666666]'>{item.name}</h2>
                            </div>

                            <h2 className="text-[12px] leading-5 font-urbanist-regular font-semibold">{sortedPieData[0]?.percentage}%</h2>
                        </div>
                    )
                })}
            </div> */}
        </div>
    );
}

export default ConversionRateGraph;
